import { forwardRef } from "react";
import { useSnackbar } from "notistack";
import { CloseSquare } from "iconsax-react";

const WarningSnackbar = forwardRef<HTMLDivElement, { message: string }>(({ message }, ref) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <div ref={ref} className="bg-white border-l-8 border-[#F59E0B] p-4 rounded-lg flex items-center justify-between gap-10 z-[9999999]">
      <div className="flex items-center gap-2">
        <span className="flex items-center justify-center size-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="size-6" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </span>
        <span className="text-xs text-closed-shutter-300">{message}</span>
      </div>
      <button className="size-6" onClick={() => closeSnackbar()}>
        <CloseSquare className="size-6" variant="Broken" />
      </button>
    </div>
  );
});

WarningSnackbar.displayName = "WarningSnackbar";

export default WarningSnackbar;
